import { LocationService } from './../../../../../_services/location.service';
import { LoaderService } from './../../../../../_services/loader.service';
import { saveAs } from 'file-saver';
import { CmsService } from './../../../../../_services/strapi.service';
import { ActivatedRoute } from '@angular/router';
import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { File, Plugin } from 'src/app/_models/strapi-file';
import { ThemeService } from 'src/app/_services/theme.service';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
    selector: 'app-plugin-table',
    templateUrl: './plugin-table.component.html',
    styleUrls: ['./plugin-table.component.scss'],
    standalone: false
})
export class PluginTableComponent implements OnInit {
  private readonly themeService: ThemeService = inject(ThemeService);
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly cmsService: CmsService = inject(CmsService);
  private readonly loaderService: LoaderService = inject(LoaderService);
  private readonly overlayContainer: OverlayContainer = inject(OverlayContainer);
  private readonly locationService: LocationService = inject(LocationService);

  currentPlugin: Plugin;
  displayedColumns = ['name', 'download'];
  currentLanguage: string;
  theme: string;

  ngOnInit(): void {
    let pluginId = this.route.snapshot.paramMap.get('id');
    this.loaderService.startLoader();
    this.cmsService.getPlugin(pluginId).subscribe(
      (plugin: Plugin) => {
        this.currentPlugin = plugin;
        this.loaderService.stopLoader();
      },
      (error) => this.loaderService.stopLoader()
    );

    this.locationService.currentLanguage$.subscribe(
      (language: string) => (this.currentLanguage = language)
    );

    this.themeService.themeApplied.subscribe(
      theme => {
        if (this.theme) {
          this.renderer.removeClass(document.body, this.theme);
          this.overlayContainer.getContainerElement().classList.remove(this.theme);
        }
        this.renderer.addClass(document.body, theme);
        this.overlayContainer.getContainerElement().classList.add(theme);
        this.theme = theme;
      }
    );

  }

  // Change Theme
  toggleTheme() {
    this.themeService.toggleTheme();
  }

  downloadPlugin(file: File) {
    if (!file) {
      return;
    } else {
      this.cmsService
        .downloadPrivateFile(file.url)
        .subscribe((blob) => saveAs(blob, `${file.name}`));
    }
  }

  getIconUrl(file: File): string {
    return this.cmsService.getPrivateFileProxyUrl(file?.url || '');
  }
}
